<template>
  <v-container fluid fill-height class="pa-0 bg-nexus-dark">
    <v-row class="fill-height ma-0">
      <v-col cols="12" md="3" class="pa-0 border-right-nexus">
        <v-card
          flat
          tile
          color="#1e1e1e"
          height="100%"
          class="d-flex flex-column"
        >
          <div class="pa-4">
            <slot name="breadcrumbs"></slot>

            <div class="d-flex align-center mb-4">
              <slot name="back-button">
                <v-btn v-if="showArrowLeft" icon @click="goBack" class="mr-2 bg-hover-nexus">
                  <v-icon color="white">mdi-arrow-left</v-icon>
                </v-btn>
              </slot>

              <h1 class="text-h5 font-weight-black white--text">
                <slot name="title">Pedidos</slot>
              </h1>
            </div>

            <slot name="isBorrador"></slot>
            <slot name="subtitle"></slot>
          </div>
          <v-divider class="opacity-10"></v-divider>

          <div class="flex-grow-1 overflow-y-auto custom-scroll px-4 py-2">
            <slot name="navigation-controller"></slot>
          </div>

          <v-divider class="opacity-10"></v-divider>

          <div class="pa-4 bg-nexus-footer">
            <slot name="button-navigation-controller"></slot>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="9" class="pa-0 bg-nexus-main">
        <v-card
          flat
          tile
          color="transparent"
          height="100%"
          class="overflow-y-auto custom-scroll"
        >
          <slot name="vista-previa"></slot>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.bg-nexus-dark {
  background-color: #121212;
}
.bg-nexus-main {
  background-color: #181818;
}
.bg-nexus-footer {
  background-color: rgba(255, 255, 255, 0.02);
}
.border-right-nexus {
  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
}
.opacity-10 {
  opacity: 0.1;
}

.custom-scroll {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }
}
</style>

<script>
export default {
  name: "layout.comprobante.consultar",

  props: {
    widthNavigation: {
      type: String,
      default: "350",
    },
    showArrowLeft: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    goBack() {
      var path = "";
      if (
        this.$route.name === "pedidoVenta" ||
        this.$route.name === "pedidoCompra"
      ) {
        path = this.$route.name === "pedidoVenta" ? "ventas" : "compras";
        this.$router.push({ name: path });
      } else if (
        this.$route.name === "nuevoPedidoVenta" ||
        this.$route.name === "nuevoPedidoCompra"
      ) {
        path =
          this.$route.name === "nuevoPedidoVenta"
            ? "pedidoVenta"
            : "pedidoCompra";
        this.$router.push({ name: path });
      } else if (this.$route.name === "detalleVenta") {
        this.$router.push({ name: "ventas" });
      } else {
        this.$router.push("/home");
      }
    },
    // goToRoute(route) {
    //   this.$router.push({ name: route }).catch(() => {});
    // },
  },
};
</script>
